<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Acabado</span>
  <div class="section flex flex-row gap-2.5">
    <img
      [src]="
        coverLaminated
          ? 'assets/images/finishings/encuadernadoPortadaPlastificada.svg'
          : 'assets/images/finishings/encuadernado.svg'
      "
    />
    <div class="flex flex-col">
      <span class="section_title">{{
        coverLaminated ? 'Encuadernado con portada plastificada.' : 'Encuadernado'
      }}</span>
      <ul>
        <li>
          Para el grosor de {{ getCurrentPaperWeight() }} gr el máximo es de {{ getSheetLimit() }} folios por cada
          encuadernación.
        </li>
        <li>Superados {{ getSheetLimit() }} folios se crearán tantas encuadernaciones como sean necesarias.</li>
      </ul>
    </div>
  </div>
</div>
